import styled from "styled-components";

export const LoginStyled = styled.div`
  height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-evenly;

  section {
    padding: 2rem 0.5rem;
    background-color: var(--color-gray-3);
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    height: 75%;
  }

  span {
    font-weight: 600;
    font-size: 12px;
    line-height: 18px;
    color: var(--color-gray-1);
  }
`;

export const IconButton = styled.button`
  background-color: transparent;
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;

  svg {
    color: var(--color-gray-1);
  }
`;

export const RegisterSection = styled.div`
  margin-top: 1rem;
  display: flex;
  flex-direction: column;
  gap: 1rem;
  width: 100%;
  padding: 1rem;

  span {
    text-align: center;
  }
`;
